// @flow
import React, {PureComponent} from 'react';
import classNames from 'classnames';

type Props = {
    day: number,
    isPast: boolean,
    isToday: boolean,
    enableSameDayAvailability: boolean
};

const clickable = ({isPast, isToday, enableSameDayAvailability}: Props) => {
    return !isPast && (!isToday || enableSameDayAvailability);
};

/**
 * Stripped down version of PDP day availability
 * https://github.homeawaycorp.com/traveler/react-trip-details/blob/master/src/components/calendarTemplates/DayAvailability/DayAvailability.js
 */
class DayAvailability extends PureComponent<Props> {
    static canClick = clickable;
    static canHover = clickable;

    render() {
        const {day, isPast, isToday, enableSameDayAvailability} = this.props;
        const dateClasses = classNames({
            date: true,
            today: false,
            past: isPast || (isToday && !enableSameDayAvailability)
        });

        return <div className={dateClasses}>{day}</div>;
    }
}

export default DayAvailability;
